import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatWorkoutUrl'
})
export class FormatWorkoutUrlPipe implements PipeTransform {

  transform(media: unknown, ...args: unknown[]): unknown {
    const { week, item } = <any>media;

    const week_id = week.id
    const name = item.media[0].name
    const type = item.media[0].type
    const nameByType = (type == 'video') ? `${name}.png` : name
    const src = `/assets/medias/weeks/${week_id}/${nameByType}`

    return src;
  }

}
